<h5 class="header">
  {{'ISSUE-TEXT.SELLER-DETAILS' | translate}}
</h5>

<div class="box-content">
  <div [formGroup]="sellerForm" style="margin-bottom: -1rem;">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="seller-name">{{'ISSUE-TEXT.SELLER-NAME'|translate}}</label>
          </div>
          <div class="col-md-8">
            <ng-select class="custom" [items]="sellers" labelForId="seller-name" bindLabel="name" bindValue="name"
              placeholder="{{'FILTER.PLACEHOLDER' | translate}}" [clearable]="false" formControlName="name"
              (change)="setSeller($event)">
            </ng-select>
            <div *ngIf="sellerName.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="seller-tax-id">{{ 'ISSUE-TEXT.TAX-ID'|translate }}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="seller-tax-id" formControlName="taxID">
            <div *ngIf="sellerTaxID.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="seller-branch-code">{{'TABLE.BRANCH-CODE'|translate}}</label>
          </div>
          <div class="col-md-8">
            <div class="row align-items-center">
              <div class="col">
                <ng-select class="custom" [items]="sellerBranches" labelForId="seller-branch-code" bindLabel="code"
                  bindValue="code" placeholder="{{'FILTER.PLACEHOLDER' | translate}}" formControlName="branchCode"
                  (change)="setSellerBranch($event)">
                </ng-select>
              </div>
              <div class="col-auto text-nowrap">
                <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="isSellerHeadOffice"
                  (onChange)="setSellerHeadOffice()" [ngModelOptions]="{standalone: true}"
                  label="{{'DATA.HEAD-OFFICE'|translate}}" [disabled]="!sellerName.value || sellerBranches.length <= 1">
                </p-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="seller-branch-name">{{'TABLE.BRANCH-NAME'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="seller-branch-name" formControlName="branchName">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="seller-address">{{'FILTER.ADDRESS'|translate}}</label>
          </div>
          <div class="col-md-8">
            <textarea class="form-control" id="seller-address" rows="3" formControlName="address"></textarea>
            <div *ngIf="sellerAddress.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Force next columns to break to new line at md breakpoint and up -->
      <div class="w-100 d-none d-md-block"></div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="seller-postal-code">{{'DATA.DELIVERY-POSTALCODE'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="seller-postal-code" formControlName="postalCode">
            <div *ngIf="sellerPostalCode.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/seller-form/seller-form.component.html